<button
  class="accordion-trigger-container"
  type="button"
  [attr.data-size]="size"
  [attr.data-open]="isOpen"
  [attr.data-disabled]="disabled"
  [disabled]="disabled"
  [attr.aria-expanded]="isOpen"
  (click)="onTriggerClick()"
>
  <span class="accordion-trigger-label">
    <ng-content #content></ng-content>
    <ng-container *ngIf="!hasProjectedContent">{{ label }}</ng-container>
  </span>

  <span class="accordion-trigger-icon" [class.rotated]="!isOpen">
    <umss-icon name="phosphorCaretUp" size="16px"></umss-icon>
  </span>
</button>
